/**
 * Normalizes Learning Center launch URLs returned by PortalApi for UI rendering.
 * Access is determined by Portal permissions; this endpoint supplies labels and SSO URLs only.
 *
 * @param {{ learningCenterLinks?: Array<{ branchId?: string, label?: string, url?: string }> } | undefined} response
 * @returns {{ branchId?: string, label: string, url: string }[]}
 */
export function normalizeLearningCenterLinks(response) {
	const links = response?.learningCenterLinks;
	if (!Array.isArray(links)) {
		return [];
	}

	return links
		.filter((link) => link?.label && link?.url)
		.map((link) => ({
			branchId: link.branchId,
			label: link.label,
			url: String(link.url).trim(),
		}));
}
